import React, { Component, Fragment } from 'react'
import { Container } from '@scentregroup/ui'
import { NavigationMenuType } from '../types'
import NavigationGroup from './navigation-group'
import style from './index.scss'

class Menu extends Component {
  static propTypes = {
    navigationMenu: NavigationMenuType.isRequired,
  }

  state = {
    activeNavGroup: null,
  }

  componentDidMount() {
    window.addEventListener('click', this.handleBackgroundClick)
    window.addEventListener('touchstart', this.handleBackgroundClick, {
      passive: false,
    })
  }

  componentWillUnmount() {
    window.removeEventListener('click', this.handleBackgroundClick)
    window.removeEventListener('touchstart', this.handleBackgroundClick)
  }

  setNavigationGroups = ref => {
    this.navigationGroups = ref
  }

  handleNavGroupClick = i => {
    this.setState({
      activeNavGroup: this.state.activeNavGroup === i ? null : i,
    })
  }

  handleBackgroundClick = e => {
    if (
      this.state.activeNavGroup !== null &&
      !this.navigationGroups.contains(e.target)
    ) {
      this.setState({ activeNavGroup: null })
      e.preventDefault()
    }
  }

  render() {
    const { navigationMenu } = this.props
    return (
      <Fragment>
        {this.state.activeNavGroup !== null && (
          <div className={style.background} />
        )}
        <Container className={style.container} type="large">
          <nav
            className={style.navigationGroups}
            ref={this.setNavigationGroups}
            id="menu"
            aria-label="Main navigation"
          >
            {navigationMenu.map((group, i) => (
              <NavigationGroup
                isMenuOpen={i === this.state.activeNavGroup}
                menuIndex={i}
                key={`nav-${group.title}`}
                navigationGroup={group}
                onClick={this.handleNavGroupClick}
              />
            ))}
          </nav>
        </Container>
      </Fragment>
    )
  }
}

export default Menu
